import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import OffersPage from './scenes/OffersPage';
import OffersDetailPage from './scenes/OffersDetailPage';
import AppWrapper from './AppWrapper.tsx';
import Filters from './scenes/Filters/index.jsx';
import 'react-spring-bottom-sheet/dist/style.css';
import ClevertapReact from './utils/cleverTap.utils.js';
import HomePage from './scenes/HomePage/index.jsx';
import BrandPage from './scenes/BrandPage/index.jsx';
import NavigationWrapper from './wrapper/NavigationWrapper.jsx';
import AboutStar from './scenes/StarPage/index.jsx';
import BrandList from './scenes/BrandList/index.jsx';
import DynamicOffers from './scenes/DynamicOffers/index.jsx';
import DetailsPage from './scenes/DynamicOffers/DetailsPage/index.jsx';
import PayDay from './scenes/SalesPages/PayDay/index.jsx';
import WeekendDeals from './scenes/SalesPages/WeekendBonanza/index.jsx';
import GateWayDeals from './scenes/SalesPages/GateWayDeals/index.jsx';
import SeasonOfSavings from './scenes/SalesPages/SeasonOfSavings/index.jsx';
import RepublicDayDeals from './scenes/SalesPages/RepublicDayDeals/index.jsx';
import ValentinesDayOffers from './scenes/SalesPages/ValentinesDayOffers/index.jsx';
import HoliFestivalDeals from './scenes/SalesPages/HoliFestivalDeals/index.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter(
  [
    {
      path: '/hello',
      element: <div>Hello world!</div>,
    },
    {
      path: '/',
      element: (
        <NavigationWrapper>
          <OffersPage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/offers/:hash',
      element: (
        <NavigationWrapper>
          <OffersPage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/offers',
      element: (
        <NavigationWrapper>
          <OffersPage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/home',
      element: (
        <NavigationWrapper>
          <HomePage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/filters',
      element: <Filters />,
    },
    {
      path: '/offer/:offerId',
      element: (
        <NavigationWrapper>
          <OffersDetailPage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/brands',
      element: (
        <NavigationWrapper>
          <BrandPage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/about-star',
      element: (
        <NavigationWrapper>
          <AboutStar />
        </NavigationWrapper>
      ),
    },
    {
      path: '/merchant-list',
      element: (
        <NavigationWrapper>
          <BrandList />
        </NavigationWrapper>
      ),
    },
    {
      path: '/dynamic-offers',
      element: (
        <NavigationWrapper>
          <DynamicOffers />
        </NavigationWrapper>
      ),
    },
    {
      path: '/dynamic-offers-detailPage',
      element: (
        <NavigationWrapper>
          <DetailsPage />
        </NavigationWrapper>
      ),
    },
    {
      path: '/payday-offers',
      element: (
        <NavigationWrapper>
          <PayDay />
        </NavigationWrapper>
      ),
    },
    {
      path: '/weekend-bonanza',
      element: (
        <NavigationWrapper>
          <WeekendDeals />
        </NavigationWrapper>
      ),
    },
    {
      path: '/getaway-deals',
      element: (
        <NavigationWrapper>
          <GateWayDeals />
        </NavigationWrapper>
      ),
    },
    {
      path: '/season-of-savings',
      element: (
        <NavigationWrapper>
          <SeasonOfSavings />
        </NavigationWrapper>
      ),
    },
    {
      path: '/republic-day-offer',
      element: (
        <NavigationWrapper>
          <RepublicDayDeals />
        </NavigationWrapper>
      ),
    },
    {
      path: '/valentines-day-offers',
      element: (
        <NavigationWrapper>
          <ValentinesDayOffers />
        </NavigationWrapper>
      ),
    },
    {
      path: '/holi-deals',
      element: (
        <NavigationWrapper>
          <HoliFestivalDeals />
        </NavigationWrapper>
      ),
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      // v7_fetcherPersist: true,
      // v7_partialHydration: true,
      // v7_skipActionErrorRevalidation: true,
      // v7_normalizeFormMethod: true,
    },
  },
);

// @TODO : Clevertap account details needs to moved to the .env file
// Customer details needs to be fetched dynamically
const searchParams = new URLSearchParams(window.location.search);
const urlParams = Object.fromEntries(searchParams.entries());
const { cid = '' } = urlParams;

const clevertap_account_id = '8W8-5Z8-966Z';
const customer_name = 'Twid App User';
const customer_id = cid;
const mobile = '';
const clevertap_profile_details = {};

ClevertapReact.initialize(
  clevertap_account_id,
  customer_name,
  customer_id,
  mobile,
  clevertap_profile_details,
);

const Loader = () => <div className="loader">Loading Merchant Offers</div>;

root.render(
  <Suspense fallback={<Loader />}>
    <AppWrapper>
      <RouterProvider
        router={router}
        future={{
          v7_startTransition: true,
        }}
      />
    </AppWrapper>
  </Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
